import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './consent.css'
import App from './App.tsx'
import ConsentBanner from './ConsentBanner.tsx'
import { AuthProvider } from './AuthContext.tsx'
import { CelebrationProvider } from './Celebration.tsx'
import { features } from '@dzm/ui/lib'

// The wipe engine is not public yet: the site hides its card, chips and
// filters until the owner lifts this. The launcher keeps them for testing.
features.wipes = false
import { ErrorBoundary } from './ErrorBoundary.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary fallback={<div style={{ padding: 24, fontFamily: 'monospace', color: 'var(--muted)' }}>Something went wrong loading this page. <a href="/" style={{ color: 'var(--brand)' }}>Go home</a>.</div>}>
      <AuthProvider>
        <CelebrationProvider>
          <App />
          <ConsentBanner />
        </CelebrationProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
)
